import updateValueAtPath from '../../../services/updateValueAtPath';

import { TQuoteCheckoutHelpers } from '.';

export type TGetFinalizedQuote = {
  stripeToken: { id: string };
  email?: string;
  phone_number?: string;
};

function getFinalizedQuote(
  { stripeToken, email, phone_number }: TGetFinalizedQuote,
  { quote, user }: TQuoteCheckoutHelpers
) {
  const userPerson = user?.client?.person;
  const quoteClient = quote?.client;
  const userEmail = userPerson?.email || email || quoteClient?.email;
  const userPhoneNumber =
    userPerson?.phone_number || phone_number || quoteClient?.phone_number;

  const newHolders = quote.application.holders.map((holder) => {
    return { ...holder, email: userEmail, phone_number: userPhoneNumber };
  });

  const updatedQuote = updateValueAtPath({
    base: quote,
    path: 'application',
    updatedValues: {
      ...quote.application,
      client: {
        ...quote.application.client,
        email: userEmail,
        phone_number: userPhoneNumber,
      },
      holders: newHolders,
      billing: {
        billing_cadence: quote.application.billing?.billing_cadence,
        billing_type: 'platform_eft',
        source_token: stripeToken.id,
      },
      auto_renewal: true,
    },
  });

  return updatedQuote;
}

export default getFinalizedQuote;
